var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.388 7.078",
    width: 10,
    height: 7
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Tick"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.329 1.06L3.561 6.328l-2.5-2.5",
    "data-name": "Path 3966"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMC4zODggNy4wNzgiIHdpZHRoPSIxMCIgaGVpZ2h0PSI3Ij4KICA8ZyBkYXRhLW5hbWU9Ikljb24gLSBUaWNrIj4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNOS4zMjkgMS4wNiAzLjU2MSA2LjMyOGwtMi41LTIuNSIgZGF0YS1uYW1lPSJQYXRoIDM5NjYiLz4KICA8L2c+Cjwvc3ZnPg==";
export { SvgTick as ReactComponent };